module.exports = __webpack_public_path__ + "img/triangle_grey.c9d068cf.svg";